import { useEffect, useState } from 'react';

/**
 * Returns a loading flag that defaults to `true` on the initial render and
 * follows the upstream `isLoading` from the next render onward.
 *
 * Useful when a data hook (e.g. one that fetches inside its own `useEffect`)
 * initializes `isLoading` to `false` and only flips it to `true` after its
 * first effect fires — which causes a frame of "content" before the
 * skeleton appears. Wrapping the upstream flag with this hook eliminates
 * that flash.
 *
 * @param isLoading - The upstream loading flag to follow after mount.
 * @returns `true` on the first render, then `!hasMounted || isLoading`.
 */
export function useDeferredLoading(isLoading: boolean): boolean {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return !hasMounted || isLoading;
}
